// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__1I9UD","pageItem":"Pagination_pageItem__1Irhp","active":"Pagination_active__PlRF4"};